import {EmploymentType} from "../../core/enums/enums";

export const employmentTypeMap: Record<EmploymentType, string> = {
    [EmploymentType.NOT_SPECIFIED]: 'Ej angivet',
    [EmploymentType.NOT_EMPLOYED]: 'Ej anställd',
    [EmploymentType.HIRED]: 'Inhyrd',
    [EmploymentType.CONSULTANT]: 'Konsult',
    [EmploymentType.APPRENTICE]: 'Lärling',
    [EmploymentType.INTERNSHIP]: 'Prao',
    [EmploymentType.PROJECT_EMPLOYMENT]: 'Projektanställning',
    [EmploymentType.PROBATIONARY_EMPLOYMENT]: 'Provanställning',
    [EmploymentType.SEASONAL_WORKER]: 'Säsongsanställning',
    [EmploymentType.PERMANENT]: 'Tillsvidare',
    [EmploymentType.HOURLY_EMPLOYEE]: 'Timanställd',
    [EmploymentType.SUBSTITUTE]: 'Vikarie',
    [EmploymentType.FIXED_TERM_EMPLOYMENT]: 'Särskild visstidsanställning'
};

export const getBlockedFileFormats = [".exe", ".com", ".bat", ".dll", ".cmd", ".msi", ".vb", ".vbs", ".ws", ".wsf", ".scf", ".scr", ".pif"];
export const getBlockedFileTypes = [ "application/x-msdownload", "application/octet-stream", "application/bat", "application/cmd", "application/exe", "application/dll", "application/vbscript", "application/vbs", "application/scriptlet", "application/wsf", "application/pif"];
